import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import EmbeddableReport from '../../interfaces/embeddable-report';
import { Apollo } from 'apollo-angular';
import { GET_EMBEDDABLE_REPORT } from './graphql/embeddable-report';
import { filter } from 'rxjs/operators';
import { AlertService } from '../../alert/alert.service';

export type FilterSet = {
  [key: string]: string;
};
@Injectable({
  providedIn: 'root',
})
export class EmbeddedReportService {
  private selectedReport?: EmbeddableReport | null;

  private _reports: EmbeddableReport[] = [];
  private reports = new BehaviorSubject(this._reports);
  public reports$ = this.reports.asObservable();

  private _url: SafeResourceUrl | null = null;
  private url = new BehaviorSubject(this._url);
  public url$ = this.url.asObservable();

  public unsafeUrl: string = '';

  private _filterSet: FilterSet = {};
  private filterSet = new BehaviorSubject(this._filterSet);
  public filterSet$ = this.filterSet.asObservable();

  private _filter = '';
  private _show: boolean = false;
  private show = new BehaviorSubject(this._show);
  public show$ = this.show.asObservable();
  constructor(
    private sanitizer: DomSanitizer,
    private apollo: Apollo,
    private alertService: AlertService
  ) {}

  public getReports() {
    let sub = this.apollo
      .watchQuery({
        query: GET_EMBEDDABLE_REPORT,
      })
      .valueChanges.subscribe(({ data }) => {
        if(data){
          if (data?.embeddableReports) {
            const reports = data.embeddableReports as EmbeddableReport[];
            this._reports = reports;
            this.reports.next(reports);
          }
          sub?.unsubscribe();
        }
      });
  }
  public setShow(show: boolean) {
    this._show = show;
    this.show.next(this._show);
  }
  public setFilters(filterSet: FilterSet) {
    this._filterSet = filterSet;
    this.filterSet.next(this._filterSet);
    this.parseURL();
  }
  public selectReport(reportType: string) {
    this.selectedReport = this._reports.find(
      (report) => report.name === reportType
    );
  }

  private applyFilters(url:string):string
  {
      let matches = url.match(/{[A-Z_]*}/g);
      let filteredUrl = url;
      if (matches) {
        for (let match of matches) {
          if (match === '{FILTER}') {
            this.parseFilterSet();
            filteredUrl = filteredUrl.replace(match, this._filter);
          } else {
            filteredUrl = filteredUrl.replace(match, this.simpleReplace(match));
          }
        }
      }

      return filteredUrl;
  }
  private parseURL() {
    if (this.selectedReport) {
      let url = this.applyFilters(this.selectedReport.base_url);
      this.unsafeUrl = url;
      this._url = this.sanitizer.bypassSecurityTrustResourceUrl(url);
      this.url.next(this._url);
    }
  }
  public popupReport(
    event: Event,
    report: EmbeddableReport | string | null = null,
    filterSet: FilterSet | null = null
  ) {
    if(typeof report === 'string'){
      this.selectReport(report);
    } else if (report) {
      this.selectReport(report.name);
    }
    if (filterSet) {
      this.setFilters(filterSet);
    }
    if (this.selectedReport?.full_url) {
      event.preventDefault();
      let url = this.applyFilters(this.selectedReport.full_url);
      window.open(url, '_blank');
      return;
    }
    if (this._url) {
      event.preventDefault();
      let opened = open(
        this.unsafeUrl,
        'popup',
        'directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,height=900, width=1200, resizable=true'
      );
      if (!opened) {
        this.alertService.add(
          '',
          'Allow pop-ups in order to use this feature.'
        );
      } else {
        this.setShow(false);
      }
    }
  }
  private simpleReplace(match: string): string {
    switch (match) {
      case '{APP_ID}':
        return this.selectedReport?.app_id ?? '';
      case '{REPORT_ID}':
        return this.selectedReport?.report_id ?? '';
      case '{CTID}':
        return this.selectedReport?.ctid ?? '';
      default:
        return '';
    }
  }
  private parseFilterSet() {
    this._filter = '';
    let filterMap;
    try {
      filterMap = JSON.parse(this.selectedReport?.filter_map ?? '');
    } catch (e) {
      filterMap = null;
    }
    if (filterMap) {
      let keys = Object.keys(filterMap);
      let length = keys.length;
      for (let i = 0; i < length; i++) {
        let key = keys[i];
        if (this._filterSet.hasOwnProperty(key)) {
          this._filter += filterMap[key].replace(
            `{${key.toUpperCase()}}`,
            this._filterSet[key]
          );
        }
        if (length > 1 && i < length - 1) {
          this._filter += ' and ';
        }
      }
    }
  }
}
